export default "__VITE_ASSET__CuKlX8Ze__"